"use client";
import * as S from "./styles.ts";
import { CallRatesTabs } from "./CallRatesTabs";
import { useState } from "react";
import { CallRate, CallRatesResults } from "./CallRatesResults";
import ArchStandaloneSectionComponent from "@template/blocks/ArchStandaloneSection/component";

interface ICallRatesSearchSectionComponentProps {
}

type FailedResponse = {
  result: boolean;
  message: string;
};

type SuccessResponse = {
  description: string;
  country_name: string;
  provider: string;
  connection_cost: number;
  flag_url: string;
  landline_cost?: number;
  mobile_cost?: number;
  result: boolean;
  message: string;
};

const CallRatesSearchSectionComponent =
  ({}: ICallRatesSearchSectionComponentProps) => {
    const [results, setResults] = useState<CallRate[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const searchByNumber = async (number: string) => {
      const apiUrl = `/svc/call-costs/number?data=true`;
      try {
        setLoading(true);
        const response = await fetch(apiUrl, {
          method: "POST",
          body: JSON.stringify({ number: number }),
          headers: {
            "Content-Type": "application/json",
          },
        });
        const data: SuccessResponse = await response.json();
        if (!data.result) {
          throw new Error("No data found for the given number.");
        }
        const callRateResponse: CallRate = {
          description: data.description,
          countryName: data.country_name,
          provider: data.provider,
          connectionCost: data.connection_cost,
          flagUrl: data.flag_url,
          landlineCost: data.landline_cost,
          mobileCost: data.mobile_cost,
        };
        setResults([...results, callRateResponse]);
        setError("");
      } catch (error) {
        console.error(error);
        setError(
          "An error occurred while fetching the data. Please try again later.",
        );
      } finally {
        setLoading(false);
      }
    };

    return (
      <>
        <S.CallRatesSearchWrapper>
          <S.CallRatesSearchContainer>
            <CallRatesTabs
              onSearch={searchByNumber}
              loading={loading}
            />
          </S.CallRatesSearchContainer>
          <ArchStandaloneSectionComponent
            color="white"
            background="dark"
            style={{
              position: "absolute",
              top: 100,
            }}
          />
          <CallRatesResults
            error={error}
            results={results}
          />
        </S.CallRatesSearchWrapper>
      </>
    );
  };

export default CallRatesSearchSectionComponent;
